<template>
  <div class="input-errors">
    <div v-for="(error, index) of errors" :key="index">
      <div v-if="error.$params.type === 'minLength' && error.$property === 'phone'" class="error-msg">
        Ожидаемый формат телефона
        <br>
        +7 (900) 000-00-00
      </div>
      <div v-if="error.$params.type === 'minLength' && error.$property !== 'phone'" class="error-msg">
        Минимальная длина {{ error.$params.min }} символов
      </div>
      <div v-if="error.$params.type === 'maxLength'" class="error-msg">
        Максимальная длина {{ error.$params.max }} символов
      </div>
      <div v-if="error.$params.type === 'required'" class="error-msg">
        Поле обязательное для заполнения
      </div>
      <div v-if="error.$params.type === 'integer'" class="error-msg">
        Допустимы только цифры
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["errors"]
};
</script>

<style lang="scss" scoped>
//.input-errors {
//  position: absolute;
//}

.error-msg {
  color: red;
  margin-top: 5px;
}
</style>